module.exports = __webpack_public_path__ + "img/bnner.2fd25eeb.png";